import { Table, useQueryState } from '@ui/src';
import { feesColumns, feesSchema } from '../../hoc/tariffs/variables/fees';
import { FeeTableTypes } from './types';

const FeesTable = ({ data, onRowsSelect }: FeeTableTypes) => {
  const { sort } = useQueryState(feesSchema);

  return (
    <Table
      columns={feesColumns}
      data={data || []}
      onSort={() => {}}
      filters={{}}
      sort={sort}
      columnsLabels={{}}
      onFilterChange={() => {}}
      onRowsSelect={onRowsSelect}
      clickable
    />
  );
};

export default FeesTable;
